import React from 'react'
import AllocationMessage from '../Reusable/AllocationMessage'

function ProductDetailsDescriptionBox({
  productId,
  productMPN,
  description,
  allocationMax,
  allocationPeriod,
}) {
  return (
    <div className="prdi__description">
      {allocationPeriod && <AllocationMessage />}

      <div className="prdi__description-code">
        <p className="prdi__description-code-text">Item #: {productId}</p>
        <p className="prdi__description-code-text">MPN: {productMPN}</p>
      </div>
      <div
        className="prdi__description-text"
        dangerouslySetInnerHTML={{
          __html: description.replace(/((<ul>)|(<\/ul>))/g, ''),
        }}
      />
    </div>
  )
}

export default ProductDetailsDescriptionBox
